module.exports = __webpack_public_path__ + "media/images/avatar_male2-1c21d7d8d828a56c5d049beb3046cfc7.png";